/**
 * 判断埋点批次失败是否允许自动重试。
 *
 * 只重试没有收到 HTTP 响应的网络/超时错误和 HTTP 5xx；4xx、业务校验失败及未知错误
 * 都属于确定性失败，继续重试只会阻塞后续页面会话事件。
 */
function shouldRetryEventBatch(error) {
  if (!error || typeof error !== 'object') return false;
  const status = error.response && Number(error.response.status);
  if (Number.isFinite(status)) return status >= 500 && status <= 599;
  return Boolean(error.request || error.code === 'ECONNABORTED' || error.message === 'Network Error');
}

// 浏览器构建统一使用 ES Module，避免与 eventQueue.js 的 import/export 模式混用。
export { shouldRetryEventBatch };
